export class AuditDetailValues {
  column?: string;
  newValue?: string;
  oldValue?: string;
  dataType?: string;
}
